import FilterAmountStep from "../unit/FilterAmountStep";
import CustomFilterText from "../unit/CustomFilterText";

const getEmployersListFilters = () => [
  <CustomFilterText key="id" label="Emp #" source="id" defaultValue="" />,
  <CustomFilterText
    key="sCompany"
    label="Organization"
    source="sCompany"
    defaultValue=""
  />,
  <CustomFilterText key="sCity" label="City" source="sCity" defaultValue="" />,
  <CustomFilterText
    key="sState"
    label="State"
    source="sState"
    defaultValue=""
  />,
  //   <CustomFilterText key="sZip" label="Zip" source="sZip" defaultValue="" />,
  <CustomFilterText
    key="sConnector"
    label="Contact Name"
    source="sConnector"
    defaultValue=""
  />,
  //   <CustomFilterText key="sEmail" label="Contact Email" source="sEmail" defaultValue="" />,
  //   <CustomFilterText
  //     key="sContactPhone"
  //     label="Contact Phone"
  //     source="sContactPhone"
  //     defaultValue=""
  //   />,
  //   <FilterAmountStep
  //     key="iLoanLimit"
  //     source="iLoanLimit"
  //     label="Max Loan Amount"
  //     amountOptions={[
  //       { id: "1", name: "<$1000" },
  //       { id: "2", name: "$1000-$5000" },
  //       { id: "3", name: "$5000-$10,000" },
  //       { id: "4", name: "$10,000-$20,000" },
  //       { id: "5", name: ">$20,000" },
  //     ]}
  //     before="and"
  //   />,
  //   <FilterAmountStep
  //     key="iApplicationFee"
  //     source="iApplicationFee"
  //     label="Application Fee"
  //     amountOptions={[
  //       { id: "1", name: "<$1000" },
  //       { id: "2", name: "$1000-$5000" },
  //       { id: "3", name: "$5000-$10,000" },
  //       { id: "4", name: "$10,000-$20,000" },
  //       { id: "5", name: ">$20,000" },
  //     ]}
  //     before="and"
  //   />,
];

export default getEmployersListFilters;
